<div *ngIf="isVisible || loading" class="header header-main" [class.activeSearch]="isSearchActive">
  <air-maintenance-notification></air-maintenance-notification>
  <div class="header-container container" [class.loading]="loading">
    <label for="search-query" class="button--search button--transparent d--none d--block--sm" (click)="onSearchButtonClick()">
      <i class="icon icon-ui-search"></i>
    </label>

    <div class="header-logo">
      <a [airLink]="'/'" [userEventSource]="userEventSource.publicMenu" userEventLabel="Home">
        <div class="logo--air-miles"></div>
      </a>
    </div>

    <ng-container *ngIf="!isInMaintenance">
      <!-- Public menu navigation -->
      <air-navigation
        *ngIf="publicMenuLinks"
        [name]="'public'"
        [navigationItems]="publicMenuLinks"
        [navClass]="'d--none--sm'"
        [userEventSource]="userEventSource.publicMenu"
      ></air-navigation>

      <air-search-bar #searchBar *ngIf="!loading"></air-search-bar>

      <div class="header-actions">
        <a
          onclick="this.blur();"
          [airLink]="inboxPageUrl"
          [userEventSource]="userEventSource.personalMenu"
          userEventLabel="Inbox"
          class="button button--special"
          *ngIf="showUnreadInboxNotification"
        >
          <i class="icon icon-ui-mail animated"></i>
        </a>

        <a
          onclick="this.blur();"
          [airLink]="promotionsPageUrl"
          [userEventSource]="userEventSource.personalMenu"
          userEventLabel="Promotions"
          class="button button--special"
          *ngIf="showPromotionsNotification"
        >
          <i class="icon icon-ui-gift animated"></i>
        </a>
        <!-- Personal menu navigation -->
        <div class="nav nav--personal" *ngIf="personalMenuLinks">
          <div
            class="button button--menu"
            (click)="onPersonalButtonClick($event)"
            [ngClass]="{
              'button--menu--logged-in': isLoggedIn,
              'button--menu--no-balance': isLoggedIn && !currentUser?.balance
            }"
            role="button"
            #personalNavigationTrigger
          >
            <!-- When not logged in, show the "Inloggen" text and the icon -->
            <div *ngIf="!isLoggedIn">
              <span class="d--none--md">{{ "general.label.login" | translate }}</span>
              <i class="icon icon-ui-login"></i>
            </div>

            <!-- When logged in, show the My Miles block -->
            <div *ngIf="isLoggedIn">
              <ng-container *ngIf="currentUser?.balance">
                <div class="my-miles d--none--md">
                  <span class="my-miles__label">{{ "general.label.my_miles" | translate }}</span>
                  <span class="my-miles__total">{{ currentUser?.balance | formatNumber }}</span>
                </div>
                <i class="icon icon-ui-arrow--down"></i>
              </ng-container>
              <i class="icon icon-ui-login"></i>
            </div>
          </div>
          <air-navigation
            [hidden]="!isLoggedIn"
            [name]="'personal'"
            [navigationItems]="personalMenuLinks"
            [navigationTrigger]="personalNavigationTrigger"
            [userEventSource]="userEventSource.personalMenu"
            [requireLogin]="true"
          ></air-navigation>
        </div>
      </div>
    </ng-container>
    <air-language-switcher></air-language-switcher>
  </div>
</div>
